import PhoneRinging from '../../src/legacy/PhoneRinging.tsx';
export default PhoneRinging;
